import React from 'react';
import { SPACES } from 'common/constants/sizes';
import Icon from 'components/base/Icon';
import Text from 'components/base/Text';
import { Stack } from '@mui/material';

const GitStreamConnectionState = ({
  text,
  textColor = 'shark',
  icon,
  iconColor = 'shark'
}) => {
  return (
    <Stack direction='row' alignItems='center' marginRight={1.5}>
      <Icon name={icon} color={iconColor} size='smaller' />
      <Text size='medium' color={textColor} pl={SPACES['x-small']}>
        {text}
      </Text>
    </Stack>
  );
};

export default GitStreamConnectionState;
